import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import React, {useCallback, useEffect, useState} from "react";
import {Empty, NavBar, Collapse, Toast, Button, Dialog} from "antd-mobile";
import {userOrderList} from "../../common/ApiAction";
import {TOASTDURATION} from "../../common/Utils";

const OrderList = () => {
    const {t} = useTranslation();
    const {state} = useLocation();
    const mobile = state?.mobile || '';
    const navigate = useNavigate()
    const [list, setList] = useState<any[]>([]);

    const _getListData = useCallback(() => {
        Toast.show({icon: 'loading', content: 'Login...', duration: 0})
        userOrderList(mobile).then((res: any) => {
            Toast.clear();
            if (res.executed) {
                setList(res.data || []);
            }
        }).catch(err => {
            Toast.clear();
            Toast.show({icon: 'fail', content: err.message, duration: TOASTDURATION})
        })
    }, [mobile])

    useEffect(() => {
        if (state?.originalPassword) {
            Dialog.alert({
                title: 'Please Change Password!',
                confirmText: 'SET PASSWORD',
                closeOnMaskClick: true,
                onConfirm: () => {
                    navigate('/user/modifyPassword', {state: {userInfoId: state?.userInfoId}})
                }
            })
        }
    },[navigate, state])

    useEffect(() => {
        _getListData();
    }, [_getListData])

    const listItemDidClick = (item: any) => {
        console.log('2222item', item)
    }
    const repayBtnDidClick = (item: any, event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.stopPropagation()
        navigate('/user/repayment', {state: {orderNo: item.orderNo}})
    }
    const _getOrderStatusDesc = (status: number) => {
         if (status === 3) {
            return t('home_order_overdue'); // 使用翻译
        }
        return '';
    }
    const _renderItemUI = (title: string, data: any) => {
        return <div className={'item-box'} style={{padding: '7px 0'}}>
            <span style={{fontSize: 15, fontWeight:"400"}}>{title}</span>
            <span style={{fontSize: 15, fontWeight:"400"}}>{data}</span>
        </div>
    }
    const _renderInstallmentPlanItemUI = (item: any, index: number) => {
        return <div key={index} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
            <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight:"400"}}>{item.installmentNumber}</span>
            <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight:"400"}}>{item.dueDate}</span>
            <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight:"400"}}>{item.paidOff === 2 ? 'Repaid' : item.repaymentAmount}</span>
        </div>
    }
    const _renderRepaymentPlan = (item: any[]) => {
        return <div style={{display: "flex", flexDirection: "column"}}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight: "400"}}>{t('home_periods')}</span>
                <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight: "400"}}>{t('order_repayment_date')}</span>
                <span style={{fontSize: 12, flex: 1, textAlign: "center", fontWeight: "400"}}>{t('loan_repayment_amount')}</span>
            </div>
            {Array.isArray(item) && item.length ? item.map((i, index) => {
                return _renderInstallmentPlanItemUI(i, index)
            }) : <Empty description='No Data'/>}
        </div>
    }
    const _renderListUI = () => {
        if (list.length) {
            return <div>
                {list.map((item,index) => {
                    return <div key={index} className={'home-list'} onClick={() => listItemDidClick(item)}>
                        <div className={'item-box'} style={{padding: '14px 0'}}>
                            <span style={{fontSize: 16, fontWeight:"400"}}>{t('common_ordere_no')}：{item.orderNo}</span>
                            <span style={{fontSize: 16, fontWeight:"bold", color: "red"}}>{_getOrderStatusDesc(item.orderStatus)}</span>
                        </div>
                        <div style={{backgroundColor: '#EFEFEF', width: '100%', height: 1}}/>
                        {_renderItemUI(t('create_order_product_info'), item.model)}
                        {_renderItemUI(t('create_order_product_memory_size'), item.memorySize)}
                        {_renderItemUI(t('create_order_product_color'), item.color)}
                        {_renderItemUI(t('create_order_contract_date'), item.contractDate)}
                        <div style={{marginTop: 20}}>
                            <Collapse defaultActiveKey={['0']}>
                                <Collapse.Panel key='1' title={t('repayment_plan')}>
                                   {_renderRepaymentPlan(item.installmentPlanList)}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                        <div style={{padding: '15px 0'}}>
                            <Button onClick={(e) => repayBtnDidClick(item, e)} color='success' style={{width: '100%'}}>Make Repayment</Button>
                        </div>
                    </div>
                })}
            </div>
        }
        return <div>
            <Empty description='No Data'/>
        </div>
    }
    return <div style={{display: "flex", flexDirection: "column", width: '100%', backgroundColor: '#F5F6FA'}}>
        <NavBar backIcon={null} style={{backgroundColor: '#FFF'}}>My Orders</NavBar>
        {_renderListUI()}
    </div>
}
export default OrderList;
